module.exports = __webpack_public_path__ + "static/media/done.83f2eb54.svg";